import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './styles/index.css'
import { useAppStore } from './stores/appStore'
import { bindDocumentLang } from './i18n/documentLang'

// <html lang> follows the UI language from the first paint and on every switch.
bindDocumentLang(useAppStore)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)